export default __webpack_public_path__ + "3b8be86080a29a7caae933beae4e92d6.svg";